import { Component, ElementRef, Inject, OnInit, ViewChild, Optional } from '@angular/core';
import { FirebaseTSFirestore, OrderBy } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FirebaseTSApp } from 'firebasets/firebasetsApp/firebaseTSApp';
import { AppComponent } from 'src/app/app.component';
import { UserData } from 'src/app/models/user.model';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { PostData, CommentData } from 'src/app/models/post.model';
import WaveSurfer from 'wavesurfer.js';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from 'src/app/services/auth.service';
import { EditCommentDialogComponent } from 'src/app/edit-comment-dialog/edit-comment-dialog.component';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.css']
})
export class ReplyComponent implements OnInit {
  @ViewChild('waveform', { static: false }) waveformRef!: ElementRef;
  waveform: any;
  firestore = new FirebaseTSFirestore();
  comments: Comment[] = [];
  comments2: any [] = [];
  comment: any;
  commentators: UserData[] = [];
  profilePhotoUrl: string;
  postId: string;

  imageFile: File | null = null;
  imagePreviewUrl: string | null = null;
  storage = new FirebaseTSStorage();

  selectedImageFile: File | null = null;
  selectedImageUrl: string | null = null;

  audioBlob: Blob | null = null;
  audioBlobUrl: string | null = null;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  isRecording = false;
  isTextEntered = false;
  recordingTime = "00:00";
  postData: PostData;
  enregistrement: string = "enregistrement audio..."

  private breakpointSubscription: Subscription;
  isMobileOrTablet: boolean = false;

  @ViewChild('commentInput') commentInputRef!: ElementRef<HTMLTextAreaElement>;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: string,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private bottomSheetData: string,
    private breakpointObserver: BreakpointObserver,
    private firestore2: AngularFirestore,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
    this.postId = dialogData || bottomSheetData;
    this.breakpointSubscription = this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe(result => {
        this.isMobileOrTablet = result.matches;
      });
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    
    this.getComments();
    this.loadPost();
    
  }

  isCommentCreator(comment: Comment) {
    try {
      return comment.creatorId == AppComponent.getUserDocument().userId;
    } catch (err) {
      // Handle error
    }
  }

  onEditComment(comment: any) {
    // Ouvrir une boîte de dialogue pour modifier le commentaire
    const dialogRef = this.dialog.open(EditCommentDialogComponent, {
      width: '250px',
      data: { comment: comment.comment }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Mettre à jour le commentaire dans Firestore
        this.firestore2.collection('Posts').doc(this.postId).collection('PostComments').doc(comment.id).update({
          comment: result
        }).then(() => {
          console.log('Commentaire mis à jour avec succès');
          // Mettre à jour le commentaire localement
          const index = this.comments.findIndex(c => c.id === comment.id);
          if (index !== -1) {
            this.comments[index].comment = result;
          }
        }).catch(error => {
          console.error('Erreur lors de la mise à jour du commentaire:', error);
        });
      }
    });
  }

  onDeleteComment(comment: any) {
    // Supprimer le commentaire de Firestore
    
    this.firestore2.collection('Posts').doc(this.postId).collection('PostComments').doc(comment.id).delete().then(() => {
      console.log('Commentaire supprimé avec succès');
      // Supprimer le commentaire localement
      this.comments = this.comments.filter(c => c.id !== comment.id);
    }).catch(error => {
      console.error('Erreur lors de la suppression du commentaire:', error);
    });
  }

  // Fonction pour détecter si du texte a été saisi
  onTextChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.isTextEntered = input.value.trim().length > 0;
  }

  getComments() {
   
    this.firestore.listenToCollection(
      {
        name: "Post Comments",
        path: ["Posts", this.postId, "PostComments"],
        where: [new OrderBy("timestamp", "desc")],
        onUpdate: (result)=> {
          result.docChanges().forEach(
            postCommentDoc => {
              this.comment = postCommentDoc.doc.data();
              
              if(postCommentDoc.type == "added") {
                 
                //alert("2");  
                  //this.getCreatorInfo(this.comment.creatorId);
                console.log(this.comment);
                this.comments.unshift(this.comment);
                
                //<Comment>postCommentDoc.doc.data()
                
              }
              
              
            }
          ); 
          
          this.comments2 = this.comments;
          //alert(this.comments2.length);
          this.comments = [];
          //let j = 0;
          
          
          this.comments2.forEach(element => {
            
            //alert(element.creatorName);
            this.firestore.getDocument(
              {
                path: ["Users", element.creatorId],
                onComplete: (result) => {
                  let userDocument = <UserData> result.data();
                  
                  element.profilePhotoUrl = userDocument.profilePhotoUrl;
                  
                  //this.commentators[j] = userDocument;
                  
                  
                  //this.comments[j] = element;
                  //alert(this.comments[j].profilePhotoUrl);
                  
                  this.commentators.unshift(userDocument);
                  this.comments.unshift(element);

                  //this.creatorName = userDocument.publicName;
                  //this.creatorDescription = userDocument.description;
                  //this.creatorProfilePhotoUrl = userDocument.profilePhotoUrl;   
                           
                }
              }
            );
           
            //alert(j);
            
            
            //j++;

            

          });
          //alert(this.comments.length);
          
          

        }
      } 
    );

   
    
   
    
  }

  adjustTextareaHeight(event: any): void {
    const textarea = event.target;
    textarea.style.height = 'auto';
    textarea.style.height = (textarea.scrollHeight) + 'px';
    this.onTextChange(event);
  }

  resizeTextarea(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';  // Réinitialise la hauteur
    textarea.style.height = `${Math.min(textarea.scrollHeight, 3 * 1.5)}em`; // Limite à 3 lignes
}

  onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      this.selectedImageFile = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImageUrl = e.target.result;
      };
      reader.readAsDataURL(this.selectedImageFile);
    }
    this.isTextEntered = true;
  }

  clearSelectedImage(): void {
    this.selectedImageFile = null;
    this.selectedImageUrl = null;
    this.isTextEntered = false;
  }

  clearAudio(): void {
    this.audioBlob = null;
    this.audioBlobUrl = null;
    this.audioChunks = [];
    this.isRecording = false;
    this.isTextEntered = false;
  }

  toggleRecording(): void {
    if (this.isRecording) {
      this.stopRecording();
      this.isRecording = false;
      this.startWaveform();
    } else {
      this.startRecording();
      this.isRecording = true;
      this.isTextEntered = false;
      this.stopWaveform();
    }
  }

  startWaveform() {
    this.waveform = WaveSurfer.create({
      container: this.waveformRef.nativeElement,
      waveColor: '#aaa',
      progressColor: '#0066ff',
      cursorColor: '#0066ff',
      height: 50
    });
    // Débuter la capture audio ici et utiliser l'API Web Audio pour visualiser.
    this.waveform.load(''); // charger une source audio, si disponible
  }

  stopWaveform() {
    if (this.waveform) {
      this.waveform.destroy();
      this.waveform = null;
    }
  }

  

  startRecording(): void {
    // Masquez le champ de texte et le bouton de sélection d'image
    this.isTextEntered = false;

    this.isRecording = true;
    this.audioChunks = [];
    this.recordingTime = "00:00";

    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.start();

      this.mediaRecorder.addEventListener("dataavailable", event => {
        this.audioChunks.push(event.data);
      });

      this.mediaRecorder.addEventListener("stop", () => {
        this.audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' });
        this.audioBlobUrl = URL.createObjectURL(this.audioBlob);
      });

      // Timer
      let seconds = 0;
      const timer = setInterval(() => {
        if (!this.isRecording) {
          clearInterval(timer);
        } else {
          seconds++;
          const minutes = Math.floor(seconds / 60);
          const displaySeconds = seconds % 60;
          this.recordingTime = `${minutes.toString().padStart(2, '0')}:${displaySeconds.toString().padStart(2, '0')}`;
        }
      }, 1000);
    });
  }

  stopRecording(): void {
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }
    this.isRecording = false;
    this.isTextEntered = true;
  }

  uploadAudio(commentText: string, commentInput: HTMLTextAreaElement): void {
    if (this.audioBlob) {
      const filePath = ['Posts', this.postId, 'Audio', new Date().getTime() + '.mp3'];
      this.storage.upload({
        uploadName: "Comment Audio Upload",
        path: filePath,
        data: { data: this.audioBlob },
        onComplete: (downloadUrl) => {
          this.createComment(commentText, null, downloadUrl, commentInput);
          this.clearAudio();
        },
        onFail: (err) => {
          console.error("Failed to upload audio", err);
        }
      });
    }
  }

  async onSendClick(commentInput: HTMLTextAreaElement): Promise<void> {
    if (!this.isTextEntered && !this.selectedImageUrl && !this.audioBlobUrl) return;
    
    try {
      const commentText = commentInput.value.trim();
      if (commentText.length === 0 && !this.selectedImageFile && !this.audioBlob) {
        return;
      }

      if (this.selectedImageFile) {
        this.uploadImage(commentText, commentInput);
      } else if (this.audioBlob) {
        this.uploadAudio(commentText, commentInput);
      } else {
        this.createComment(commentText, null, null, commentInput);
      }
      
      // Réinitialise le textarea
      this.resetTextarea(commentInput);
      
      // Réinitialise les autres états si nécessaire
      this.selectedImageUrl = '';
      this.audioBlobUrl = '';
      this.selectedImageFile = null;
      this.audioBlob = null;
      
    } catch (error) {
      console.error('Error sending comment:', error);
    }
  }

  private resetTextarea(commentInput: HTMLTextAreaElement) {
    commentInput.value = '';
    commentInput.style.height = 'auto';
    this.isTextEntered = false;
  }

  addNotification(postId: string, interactionType: string, recipientUserId: string, senderUserId: string, senderUserName: string, commentId: string) {
    
    const firestore = new FirebaseTSFirestore();
  
    const notification = {
      postId: postId,
      interactionType: interactionType,  // 'like' or 'comment'
      recipientUserId: recipientUserId,  // The owner of the post
      senderUserId: senderUserId,        // The person who liked or commented
      senderUserName: senderUserName,
      timestamp: new Date().toISOString(),
      isRead: false,
      commentId: commentId
    };
  
    if(recipientUserId != senderUserId){
      firestore.create({
        path: ["Notifications"],
        data: notification,
        onComplete: () => {
          console.log("Notification added successfully");
        },
        onFail: (err) => {
          console.error("Failed to add notification:", err);
        }
      });
    }
  }

  loadPost() {
    this.firestore.getDocument({
      path: ['Posts', this.postId],
      onComplete: result => {
        this.postData = result.data() as PostData; // Charger les données de la publication
        
      },
      onFail: err => {
        console.error('Erreur de chargement de la publication :', err);
      }
    });
  }

  uploadImage(commentText: string, commentInput: HTMLTextAreaElement): void {
    if (this.selectedImageFile) {
      const filePath = ['Posts', this.postId, 'Images', new Date().getTime() + '.png'];
      this.storage.upload({
        uploadName: "Comment Image Upload",
        path: filePath,
        data: { data: this.selectedImageFile },
        onComplete: (downloadUrl) => {
          this.createComment(commentText, downloadUrl, null, commentInput);
          this.clearSelectedImage();
        },
        onFail: (err) => {
          console.error("Failed to upload image", err);
        }
      });
    }
  }

  createComment(commentText: string, imageUrl?: string, audioUrl?: string, commentInput?: HTMLTextAreaElement): void {
    this.firestore.create({
      path: ['Posts', this.postId, 'PostComments'],
      data: {
        comment: commentText,
        creatorId: AppComponent.getUserDocument().userId,
        creatorName: AppComponent.getUserDocument().publicName,
        profilePhotoUrl: AppComponent.getUserDocument().profilePhotoUrl,
        imageUrl: imageUrl || '',
        audioUrl: audioUrl || '',
        timestamp: FirebaseTSApp.getFirestoreTimestamp(),
      },
      onComplete: (docId) => {
        this.resetTextarea(commentInput);
        console.log('Comment created successfully with ID:', docId);
        this.firestore.update({
          path: ['Posts', this.postId, 'PostComments', docId],
          data: {
            id: docId
          },
          onComplete: (docIdAjouté) => {
            
          }
        });
        this.addNotification(this.postId, "commenté", this.postData.creatorId, AppComponent.getUserDocument().userId, AppComponent.getUserDocument().publicName, docId);
        
      },
      onFail: (err) => {
        console.error("Failed to create comment", err);
      }
    });
  }

  getLastMessageFormattedDate(comment: Comment): string {
    

  if (comment.timestamp) {
    if (comment.timestamp.toDate) {
        // Si timestamp est un Firestore Timestamp
        comment.timestamp = comment.timestamp.toDate().toISOString();
    } else {
        // Si timestamp est déjà un string ou un autre type
        comment.timestamp = new Date(comment.timestamp).toISOString();
      }
  }


    const timestamp = comment.timestamp ? new Date(comment.timestamp) : new Date();
    const now = new Date();

    // Calcul de la différence en millisecondes entre la date actuelle et la date de la notification
    const diffMs = now.getTime() - timestamp.getTime();
  
    // Conversion des millisecondes en minutes, heures, jours, semaines, mois et années
    const diffMinutes = Math.floor(diffMs / (1000 * 60)); // Différence en minutes
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60)); // Différence en heures
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // Différence en jours
    const diffWeeks = Math.floor(diffDays / 7); // Différence en semaines
    const diffMonths = Math.floor(diffDays / 30); // Différence en mois approximatif
    const diffYears = Math.floor(diffDays / 365); // Différence en années approximatif
  
    // Logique pour afficher le temps écoulé
    if (diffMinutes < 1) {
      return `à l'instant`;
    } else if (diffMinutes < 60) {
      return `il y a ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    } else if (diffHours < 24) {
      return `il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
    } else if (diffDays < 7) {
      return `il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
    } else if (diffWeeks < 4) {
      return `il y a ${diffWeeks} semaine${diffWeeks > 1 ? 's' : ''}`;
    } else if (diffMonths < 12) {
      return `il y a ${diffMonths} mois`;
    } else {
      return `il y a ${diffYears} an${diffYears > 1 ? 's' : ''}`;
    }
  
    
  }

  onKeydown(event: KeyboardEvent): void {
    const commentInput = this.commentInputRef.nativeElement;
    if (event.key === 'Enter') {
      if (this.isMobileOrTablet || event.shiftKey) {
        // Sur mobile/tablet ou avec Shift+Enter, on ajoute une nouvelle ligne
        return;
      } else {
        // Sur desktop sans Shift, on envoie le commentaire
        event.preventDefault();
        this.onSendClick(commentInput);
      }
    }
  }

  onCreateReply(): void {
    const commentText = this.commentInputRef.nativeElement.value.trim();
    if (commentText.length > 0) {
      this.createComment(commentText);
      this.commentInputRef.nativeElement.value = '';
    }
  }
}


export interface Comment {
  id: string;
  creatorId: string;
  creatorName: string;
  comment: string;
  timestamp: any;
  profilePhotoUrl: string;
  imageUrl?: string;
}
